/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Orcontinuewith2Inputs */

const zh_auth_orcontinuewith2 = /** @type {(inputs: Auth_Orcontinuewith2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或通过以下方式继续`)
};

const en_auth_orcontinuewith2 = /** @type {(inputs: Auth_Orcontinuewith2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or continue with`)
};

const es_auth_orcontinuewith2 = /** @type {(inputs: Auth_Orcontinuewith2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O continuar con`)
};

/**
* | output |
* | --- |
* | "Or continue with" |
*
* @param {Auth_Orcontinuewith2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_orcontinuewith2 = /** @type {((inputs?: Auth_Orcontinuewith2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Orcontinuewith2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_orcontinuewith2(inputs)
	if (locale === "en") return en_auth_orcontinuewith2(inputs)
	return es_auth_orcontinuewith2(inputs)
});
export { auth_orcontinuewith2 as "auth_orContinueWith" }